export const colors = {
  yellow: "#F9ED24",
  red: "#ff8345",
  blue: "#0FBCBC",
  beige: "#EFE1BA",
}
